var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Building Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M3.125 1.66669H11.875C12.1914 1.66669 12.4529 1.90182 12.4943 2.20688L12.5 2.29169V4.16669H16.875C17.2202 4.16669 17.5 4.44651 17.5 4.79169V17.9167C17.5 18.1468 17.3135 18.3334 17.0833 18.3334H14.5833C14.3532 18.3334 14.1667 18.1468 14.1667 17.9167V15H11.6667V17.9167C11.6667 18.1468 11.4801 18.3334 11.25 18.3334H8.75C8.51988 18.3334 8.33333 18.1468 8.33333 17.9167V4.79169C8.33333 4.44651 8.61316 4.16669 8.95833 4.16669H11.25V2.91669H3.75V17.7084C3.75 18.0535 3.47018 18.3334 3.125 18.3334C2.80859 18.3334 2.54709 18.0982 2.50571 17.7932L2.5 17.7084V2.29169C2.5 1.97527 2.73513 1.71378 3.04019 1.67239L3.125 1.66669ZM6.66667 14.1667V15.8334H5V14.1667H6.66667ZM6.66667 11.6667V13.3334H5V11.6667H6.66667ZM12.5 11.6667H10.8333V13.3334H12.5V11.6667ZM15 11.6667H13.3333V13.3334H15V11.6667ZM6.66667 9.16669V10.8334H5V9.16669H6.66667ZM12.5 9.16669H10.8333V10.8334H12.5V9.16669ZM15 9.16669H13.3333V10.8334H15V9.16669ZM6.66667 6.66669V8.33335H5V6.66669H6.66667ZM12.5 6.66669H10.8333V8.33335H12.5V6.66669ZM15 6.66669H13.3333V8.33335H15V6.66669ZM6.66667 4.16669V5.83335H5V4.16669H6.66667Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingFilled);
export default __webpack_public_path__ + "static/media/building-filled.56ec21f8218339715deb5eab488f8708.svg";
export { ForwardRef as ReactComponent };